import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    loading: false,
    current_event: null,
    events: []
  },
  mutations: {
    SET_EVENT_MANAGER_LOADING(state, payload) {
      state.loading = payload
    },
    SET_EVENT_MANAGER_CURRENT_EVENT(state, payload) {
      state.current_event = payload
    },
    SET_EVENT_MANAGER_EVENTS(state, payload) {
      state.events = payload
    }
  },
  actions: {
    async fetchEventLibrary({ commit }) {
      try {
        commit('SET_EVENT_MANAGER_LOADING', true)
        commit('SET_EVENT_MANAGER_EVENTS', [])
        const response = await api.getEventOverview()
        if (response.data.success) {
          commit('SET_EVENT_MANAGER_EVENTS', response.data.data.events)
          let current_event = Object.keys(response.data.data.active).length === 0 ? null : response.data.data.active
          commit('SET_EVENT_MANAGER_CURRENT_EVENT', current_event)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_EVENT_MANAGER_LOADING', false)
      }
    },
    async updateCurrentEvent({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.setting_current_event'),
          loading: true
        })
        const device_id = rootState.auth.selected_device
        const response = await api.updateEvent({ params: { device_id, is_active: payload.is_active }, event_id: payload.event_id })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.current_event'),
            icon: 'check',
            timeout: '2000'
          })
          dispatch('fetchEventLibrary')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async duplicateEvent({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.duplicating', Vuetify.locale.t('$vuetify.__EventManager.event')),
          loading: true
        })
        const device_id = rootState.auth.selected_device
        const response = await api.duplicateEvent({ params: { device_id }, event_id: payload.event_id })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.duplicate', Vuetify.locale.t('$vuetify.__EventManager.event')),
            icon: 'check',
            timeout: '2000'
          })
          dispatch('fetchEventLibrary')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
